module.exports = __webpack_public_path__ + "static/media/attach.10cb60b6.svg";